import React, { useCallback, useEffect, useState } from 'react'
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom'
import StatusMessage, { useStatusMessage } from '../../../ui/StatusMessage/StatusMessage'
import useAmeCampaignsSubscription from '../../../api/marketing/ameCampaigns/useAmeCampaignsSubscription'
import AmeCampaignsTable from './AmeCampaignsTable'
import AmeCampaignEditor from './AmeCampaignEditor'
import AmeCampaignPromoCodesPopUp, { FILTER_ALL, FILTER_USED } from './AmeCampaignPromoCodesPopUp'

function AmeCampaignsList() {
  const history = useHistory()
  const location = useLocation()
  const [statusMessage, setStatusMessage] = useStatusMessage()
  const { campaigns, isLoading, error } = useAmeCampaignsSubscription()
  const [codesPopUp, setCodesPopUp] = useState(null)

  useEffect(() => {
    if (!location.state?.justSaved) return
    setStatusMessage({
      show: true,
      type: 'success',
      message: 'Акцію збережено',
      closeAfter: 4000,
    })
    history.replace('/marketing/ame')
  }, [location.state, history, setStatusMessage])

  useEffect(() => {
    if (!error) return
    setStatusMessage({
      show: true,
      type: 'fail',
      message: error,
      closeAfter: 6000,
    })
  }, [error, setStatusMessage])

  const handleOpenCodes = useCallback(({ campaign, filter }) => {
    if (!campaign?.id) return
    setCodesPopUp({
      campaign: { id: campaign.id, title: campaign.title || '', issue: campaign.issue || null },
      filter: filter === FILTER_USED ? FILTER_USED : FILTER_ALL,
    })
  }, [])

  return (
    <>
      {statusMessage.show ? (
        <StatusMessage className="Site-StatusMessage" type={statusMessage.type} message={statusMessage.message} />
      ) : null}
      <AmeCampaignsTable campaigns={campaigns} isLoading={isLoading} onOpenCodes={handleOpenCodes} />
      {codesPopUp ? (
        <AmeCampaignPromoCodesPopUp
          campaign={codesPopUp.campaign}
          initialFilter={codesPopUp.filter}
          onClose={() => setCodesPopUp(null)}
        />
      ) : null}
    </>
  )
}

function MarketingAmeCampaigns() {
  return (
    <Switch>
      <Route exact path="/marketing/ame" component={AmeCampaignsList} />
      <Route exact path="/marketing/ame/new" component={AmeCampaignEditor} />
      <Route exact path="/marketing/ame/:id" component={AmeCampaignEditor} />
      <Route render={() => <Redirect to="/marketing/ame" />} />
    </Switch>
  )
}

export default MarketingAmeCampaigns
